import {
  computePercent,
  deriveCompletedSections,
  getSections,
  setStoredProfileCompletion,
} from './profile-completion-sections'

function isComplete(percent) {
  return percent === 100
}

export default function syncProfileCompletion({
  artist,
  previousArtist,
  community,
  updateArtistBadge,
}) {
  if (!community || !community.teachingArtistProfileCompletionEnabled)
    return Promise.resolve()
  if (!artist) return Promise.resolve()

  const sections = getSections()
  const completedSections = deriveCompletedSections(artist).filter(
    (sectionKey) => sections.includes(sectionKey)
  )
  const percent = computePercent(completedSections.length, sections.length)

  setStoredProfileCompletion(artist.id, {
    sectionsCompleted: completedSections,
    percentCompletion: percent,
  })

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('artist-profile-completion-updated'))
  }

  const previousCompletedCount = previousArtist
    ? deriveCompletedSections(previousArtist).filter((sectionKey) =>
        sections.includes(sectionKey)
      ).length
    : completedSections.length
  const previousPercent = computePercent(
    previousCompletedCount,
    sections.length
  )
  const didCompletionStateChange =
    isComplete(previousPercent) !== isComplete(percent)

  if (didCompletionStateChange && typeof updateArtistBadge === 'function') {
    return Promise.resolve(
      updateArtistBadge({
        taProfile: isComplete(percent),
      })
    ).catch(() => Promise.resolve())
  }

  return Promise.resolve()
}
